import get from 'lodash/get';
import { request } from 'lib';
import { UiToast, UiModal } from 'components';
import { getGlobalStore, globalStore } from 'stores';
import styled from 'styled-components';
import throttle from 'lodash/throttle';
import { getStore } from '../store';

// 接口文档
// https://mock.memeyule.com/project/16/interface/api/23470

const loadInfo = throttle(() => {
  const {
    room: { roomInfo, roomId },
    lianmai: { maskPk },
  } = getStore();
  request.cryolite
    .get('/api/v1/maskpk/info', {
      room_id: roomId,
    })
    .then((res) => {
      // res.data = {
      //   "pk_duration": 60,
      //   crit_info: {
      //     duration: 100,
      //   },
      //   "mode_info": {
      //     "id": "689c44d37d72821423a4543e",
      //     "stage": 2,
      //     "stage_desc": "PK中",
      //     "duration": 60,
      //     "remain_time": 59,
      //     "multi_pk_info": [
      //       {
      //         "room_id": 0,
      //         "pk_value": 1000,
      //         "pk_result": 0,
      //         "nickname": "昵称昵称昵称昵称昵称昵称",
      //         "pic": ""
      //       },
      //       {
      //         "room_id": 100000001,
      //         "pk_value": 2000,
      //         "pk_result": 0,
      //         "nickname": "昵称昵称昵称昵称昵称昵称",
      //         "pic": ""
      //       }
      //     ]
      //   }
      // }

      // res.data = {
      //     "pk_duration": 300,
      //     "mode_info": {
      //       "id": "68edff3838593e78346f03ab",
      //       "stage": 2,
      //       "stage_desc": "PK中",
      //       "duration": 300,
      //       "remain_time": 149,
      //       "multi_pk_info": [
      //         {
      //           "room_id": 100000001,
      //           "pk_value": 0,
      //           "pk_result": 0,
      //           "nickname": "昵称昵称昵称昵称昵称昵称昵称昵称昵称昵称昵称",
      //           "pic": "",
      //           "prop_name": "",
      //           "props": {
      //             "nlt": {
      //               "remain": 15,
      //               "total": 15
      //             },
      //             "nlyl": {
      //               "remain": 13,
      //               "total": 15
      //             },
      //             "ywd": {
      //               "remain": 26,
      //               "total": 30
      //             },
      //             "wxkj": {
      //               "remain": 0,
      //               "total": 30
      //             },
      //             "bonus": 0.7
      //           }
      //         },
      //         {
      //           "room_id": 0,
      //           "pk_value": 0,
      //           "pk_result": 0,
      //           "nickname": "",
      //           "pic": "",
      //           "prop_name": "",
      //           "props": {
      //             "nlt": {
      //               "remain": 0,
      //               "total": 15
      //             },
      //             "nlyl": {
      //               "remain": 0,
      //               "total": 15
      //             },
      //             "ywd": {
      //               "remain": 0,
      //               "total": 30
      //             },
      //             "wxkj": {
      //               "remain": 0,
      //               "total": 30
      //             },
      //             "bonus": 0
      //           }
      //         }
      //       ]
      //     }
      // }
      maskPk.updateInfo(res.data);
    })
    .catch((err) => {
      console.error(err);
    });
}, 2000);

// 关播时退出
const liveOffExit = async () => {
  const info = get(getStore(), 'lianmai.maskPk.info') || {};

  if (info.isMatching) {
    cancelMatch();
  }
  if (info.isPk) {
    UiToast.fail('正在蒙面PK中');
    throw new Error('正在蒙面PK中');
  }
};

const joinMatch = () => {
  request.cryolite
    .post('/api/v1/maskpk/match', null, {
      event: 'maskPk',
      event_type: 'joinMatch',
      desc: '发起匹配',
    })
    .then((res) => {
      reload();
      UiToast.success(res.msg || '已发起匹配');
    })
    .catch((res) => {
      reload();
      UiToast.fail(res.msg || '操作异常');
    });
};

const cancelMatch = (matchingId) => {
  request.cryolite
    .post(
      '/api/v1/maskpk/match/cancel',
      {
        matchingId,
      },
      {
        event: 'maskPk',
        event_type: 'cancelMatch',
        desc: '取消匹配',
      },
    )
    .then((res) => {
      reload();
      UiToast.success(res.msg || '已取消匹配');
    })
    .catch((res) => {
      reload();
      UiToast.fail(res.msg || '操作异常');
    });
};

const reload = () => {
  loadInfo();
};

const Content = styled.div`
  dt {
    font-size: 14px;
    font-weight: 600;
    padding: 10px 0 6px;
  }
  ul {
    list-style: disc;
    padding-left: 1.5em;
  }
`;
const showHelp = () => {
  UiModal.alert({
    title: '蒙面PK玩法介绍',
    width: 460,
    isShowFooter: false,
    content: (
      <Content>
        <dl>
          <dt>蒙面机制</dt>
          <dd>
            <ul>
              <li>由主播发起，进行双人不连屏PK。</li>
              <li>PK结束前，不展示对方身份，直至PK结束，双方可查看对方身份。</li>
            </ul>
          </dd>
          <dt>胜负判定</dt>
          <dd>
            <ul>
              <li>
                配对成功后，PK限时 300 秒，PK结束时直接以PK
                值高低作为胜负判定，PK值高的一方获胜，根据用户送出礼物/守护对应的柠檬价值，1
                柠檬=1PK 值；双方PK
                值相同时，则双方主播结果为平局。特殊活动期间，PK值计算和判定等，以活动规则为准。
              </li>
              <li>
                进入 PK 的 第100 秒～240 秒期间，若主播双方PK 差值 ≥ 20000，触发“斩杀时刻”，30
                秒内未能将PK 值差距缩小至 20000 内，则本场PK直接结束，PK值高的一方为获胜方；若30
                秒内PK 值差距缩小至 20000 内，则解除“斩杀时刻”状态。
              </li>
            </ul>
          </dd>
          <dt>获胜奖励</dt>
          <dd>
            <ul>
              <li>获胜主播直播间+5000热度，持续30分钟。</li>
              <li>在“蒙面PK”相关活动上线时，进行PK可获得更多奖励。</li>
            </ul>
          </dd>
        </dl>
      </Content>
    ),
  });
};

export default {
  loadInfo,
  liveOffExit,
  joinMatch,
  cancelMatch,
  reload,
  showHelp,
};
